import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
import { getUser } from '@/store/partials/user'
import Home from '@/components/Home'
import ParentRouter from '@/components/ParentRouter' // Products的分繼點，才可使用children
import ProductsList from '@/components/products/ProductsList'
import Product from '@/components/products/Product'
import ProductRegistration from '@/components/products/ProductRegistration'
import Faq from '@/components/Faq'
import CartParentRouter from '@/components/CartParentRouter'
import CartInfo from '@/components/cart/Info'
// import Payment from '@/components/cart/Payment'
import Result from '@/components/cart/Result'
import Policy from '@/components/Policy'
import Collection from '@/components/Collection'
import CargoInquiry from '@/components/CargoInquiry'
import SearchResults from '@/components/SearchResults'
import Sitemap from '@/components/Sitemap'
import Calendar from '@/components/Calendar'
import HolaSSO from '@/components/partial/HolaSSO';

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/classes',
            component: ParentRouter,
            children: [{
                    path: '/',
                    redirect: {
                        name: 'home'
                    }
                },
                {
                    path: ':id',
                    name: 'products.index',
                    component: ProductsList,
                    props: true
                },
                {
                    path: ':parentid/:id', // :id必要 :id?非必要
                    component: ParentRouter,
                    props: true,
                    children: [{
                            path: '/',
                            component: Product,
                            name: 'products.show',
                            props: true
                        },
                        {
                            path: 'register',
                            component: ProductRegistration,
                            name: 'products.register',
                            props: true
                        }
                    ]
                },
            ]
        },
        {
            path: '/cart',
            component: CartParentRouter,
            children: [{
                    path: '/',
                    name: 'cart.index',
                    component: CartInfo,
                    meta: {
                        requiresAuth: true,
                    },
                },
                // 暫時隱藏
                // {
                //     path: 'payment',
                //     name: 'cart.payment',
                //     component: Payment,
                //     meta: {
                //         requiresAuth: true,
                //     },
                // },
            ]
        },
        {
            path: '/cart/result',
            name: 'cart.result',
            component: Result,
            meta: {
                requiresAuth: true,
            },
            props: true,
        },
        {
            path: '/collection',
            name: 'collection',
            component: Collection,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/shelves',
            name: 'shelves',
            component: ProductsList,
            props: {
                id: '新上架',
                filterConditionID: 2
            }
        },
        {
            path: '/popular',
            name: 'popular',
            component: ProductsList,
            props: {
                id: '熱門區',
                filterConditionID: 3
            }
        },
        {
            path: '/trailer',
            name: 'trailer',
            component: ProductsList,
            props: {
                id: '預告區',
                filterConditionID: 4
            }
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/policy',
            name: 'policy',
            component: Policy,
        },
        {
            path: '/sitemap',
            name: 'sitemap',
            component: Sitemap,
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
        },
        {
            path: '/orders',
            name: 'orders',
            component: CargoInquiry,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/searchresults',
            name: 'searchresults',
            component: SearchResults,
            props: (route) => ({ searchKeyword: route.query.keyword }), // 使用 Vue 提供的route.query設定網址
        },
        {
            path: '/TLW',
            name: 'tlw_home',
            component: Home,
        },
        {
            path: '/HOLA',
            name: 'hola_home',
            component: Home,
        },
        {
            path: '/SSOHolaEc',
            component: HolaSSO,
        },
        {
            path: '*',
            redirect: {
                name: 'home'
            }
        }
    ],
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
});

router.beforeEach((to, from, next) => {
    const { ATMBank,
        ATMAccount,
        PayPrice,
        ATMLimitDate,
        Organizer,
        ResponseCode,
        ResponseMessage,
        OrderNo} = to.query;

    if (ResponseCode) {
        const result = { ATMAccount, ATMBank, ATMLimitDate, PayPrice, Organizer, ResponseCode, ResponseMessage, OrderNo };
        next({name: 'cart.result', params: { result, type: 'Credit'} });
    }

    if(to.matched.some(record => record.meta.requiresAuth)) {
        let user = getUser();

        if (user.Token) {
            next();
            
        } else {
            store.commit('user/setUser', {});
            store.commit('user/setShowModal', true);
            next({
                name: 'home',
            })
        }
    } else {
        next() 
    }
});

export default router
